module.exports = __webpack_public_path__ + "img/black-vip-zone.e35c8427.png";